module.exports = __webpack_public_path__ + "static/lead-white-0d22883110ee39b851ac30d0be588531.png";